const defaultCoreState = () => ({
  cityCollection: [],
});

const initialState = {
  ...defaultCoreState(),
};

export default {
  ...initialState,
};
